import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { filter, fromEvent } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DocumentVisibilityService {
  visibilityChange$ = fromEvent(this.document, 'visibilitychange');
  visible$ = this.visibilityChange$.pipe(
    filter(() => this.document.visibilityState === 'visible'),
  );

  constructor(@Inject(DOCUMENT) private readonly document: Document) {}
}
